import FeedbackView from '../../components/FeedbackView'
import Page from '../../components/Page'

const FeedbackPage = () => {
  return <Page title='Feedback'>
    <FeedbackView />
  </Page>
}

export default FeedbackPage
